import React, { Component } from "react";
import { connect } from "react-redux";
import { changeView, setDemographics } from "./../actions/assessment";
import { SaveUserStateToServerHelper } from "./Helper";
import DemographicOptions from "./DemographicOptions";
import { Modal } from "react-bootstrap";
import warningIcon from "./../assets/img/icon-warning.svg";

import { Translate } from "react-redux-i18n";

export class Demographic extends Component {
    state = {
        show_modal: false,
        modal_message: ""
    };

    componentDidMount() {
        SaveUserStateToServerHelper(this.props.assessment);
    }

    setDemographic = () => {
        return;
    }

    closeModal = () => {
        this.setState({ show_modal: false });
    };

    submitDemogrphics = () => {
        const selected_demographics = [];
        const demographics = document.getElementsByClassName("demographics");

        for (let index = 0; index < demographics.length; index++) {
            const demographic_value = demographics[index].value;
            const demographic_name = demographics[index].getAttribute("name");

            if (!demographic_value || demographic_value.length === 0) {
                this.setState({
                    show_modal: true,
                    modal_message: <Translate value="demo_req" demo={demographic_name} />
                });
                return;
            }

            selected_demographics.push(demographic_value);
        }
        this.props.setDemographics(selected_demographics);

        if (Object.keys(this.props.sport_demographic_fields).length > 0) {
            return this.props.changeView("sport_demographic");
        }

        return this.props.changeView("session_details");
    };

    render() {
        const i18n = require('react-redux-i18n').I18n;
        const demographic_list = this.props.demographic_fields.map(
            demographic_field => {
                return (
                    <DemographicOptions
                        key={demographic_field.id}
                        name={demographic_field.name}
                        label={demographic_field.name}
                        options={demographic_field.demographic_options}
                        demographicOnChange={this.setDemographic}
                    />
                );
            }
        );

        return (
            <div>
                <div className="main container-fluid h-100">
                    <div className="row justify-content-center align-items-center">
                        <div className="col-12">
                            <div className="container">
                                <div className="row justify-content-center">
                                    <div className="col-md-6">
                                        <div className="test-info">
                                            <h3 className="mt-4 mb-3 text-center">
                                                <Translate value="demo_info" />
                                            </h3>
                                            <small>
                                                <p>
                                                    <Translate value="demo_p1" />
                                                </p>
                                            </small>

                                            {demographic_list}

                                            <div className="button-wrap mt-4">
                                                <button
                                                    className="btn btn-main btn-global btn-block"
                                                    onClick={this.submitDemogrphics}
                                                >
                                                    <Translate value="submit" />
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <Modal
                    show={this.state.show_modal}
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                >
                    <Modal.Body>
                        <div className="text-center mt-5 mb-5">
                            <img src={warningIcon} className="icon" alt={i18n.t("expired")} />
                            <br />
                            <br />
                            {/* <h2 className="title">
                Warning
              </h2> */}
                            <p>{this.state.modal_message}</p>

                            <div className="button-wrap mt-md-5">
                                <button
                                    className="btn btn-success btn-sm"
                                    // data-dismiss="modal"
                                    onClick={this.closeModal}
                                >
                                    <Translate value="close" />
                                </button>
                            </div>
                        </div>
                    </Modal.Body>
                </Modal>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    ...state,
    demographic_fields: state.assessment.demographic_fields,
    sport_demographic_fields: state.assessment.sport_demographic_fields
});

const mapDispatchToProps = dispatch => ({
    changeView: next_view => dispatch(changeView(next_view)),
    setDemographics: demographics => dispatch(setDemographics(demographics))
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Demographic);
